interface ResultsModalProps {
  failedGroups: Array<{ group: string; error: string }>;
  getGroupName: (groupId: string) => string;
  onClose: () => void;
  onRetry?: () => void;
  missingCount?: number;
}

export const ResultsModal = ({ failedGroups, getGroupName, onClose, onRetry, missingCount }: ResultsModalProps) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-96 overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">📋 Detalhes dos Grupos com Falha</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-xl font-bold"
          >
            ✕
          </button>
        </div>
        <div className="space-y-2">
          {failedGroups.map((fail, index) => (
            <div key={index} className="p-3 bg-red-50 rounded border border-red-200">
              <div className="font-medium text-red-800">
                {getGroupName(fail.group)}
              </div>
              <div className="text-sm text-red-600 mt-1">
                Erro: {fail.error}
              </div>
            </div>
          ))}
        </div>
        {onRetry && missingCount && missingCount > 0 && (
          <div className="mt-4 pt-4 border-t border-gray-200 flex gap-2 justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm rounded border border-gray-300 hover:bg-gray-50"
            >
              Fechar
            </button>
            <button
              onClick={onRetry}
              className="px-4 py-2 text-sm rounded bg-yellow-400 hover:bg-yellow-500 text-yellow-900 font-semibold"
            >
              🔄 Reenviar para os {missingCount} faltantes
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
